import { FC, ReactElement } from 'react';
import { isITAREnvironment } from 'constants/env';
import Header from '../modules/header/Header';

interface IProps {
  children: ReactElement;
}

const WithHeader: FC<IProps> = ({ children }) => {
  return (
    <div className="flex h-dvh flex-col">
      <Header upgradingEnabled={!isITAREnvironment()} />
      <main className="overflow-auto">
        <div
          className={`mx-auto w-full px-4 py-3 md:max-w-[768px] md:px-6 md:py-4
            lg:max-w-[1600px] lg:px-4 xl:max-w-[1920px]`}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default WithHeader;
